import type { MutationKey, QueryKey } from '@tanstack/react-query';

export type ParamsType =
	| string
	| number
	| boolean
	| never[]
	| string[]
	| Record<string, unknown>
	| object
	| null
	| undefined;
type HttpMethod = 'get' | 'post' | 'put' | 'patch' | 'delete';

export function coreApiQueryKey(
	endpoint: string,
	method?: HttpMethod,
	params?: ParamsType
): QueryKey | MutationKey {
	return [
		`core-api:query:${endpoint}`,
		method || 'get',
		...(params ? [params] : []),
	];
}
